import React, { useEffect, useState, Fragment, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getRegions,
  toggleShowWindow,
} from '../Actions/LanguageSelector.action';
import { translate } from '../Services/translation';
import LanguageSelectorItem from './LanguageSelectorItem';
import useOnclickOutside from 'react-cool-onclickoutside';

const LanguageSelector = ({ title }) => {
  const dispatch = useDispatch();
  const { showWindow, result } = useSelector((state) => state.languageSelector);
  const [mobileWindowIndex, setMobileWindowIndex] = useState(0);
  const [languageList, setLanguageList] = useState([]);
  const [customerLang, setCustomerLang] = useState('en');
  const [selectedMobileCountry, setSelectedMobileCountry] = useState('');
  const [languageGroupList, setLanguageGroupList] = useState([]);
  const [groupedLanguagesByRegion, setGroupedLanguagesByRegion] = useState([]);
  const [regionList, setRegionList] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState('');
  const [currentLangObject, setCurrentLangObject] = useState({});
  const [fallbackChannel, setFallbackChannel] = useState({});
  const [mainImagePath, setMainImagePath] = useState('');
  const langSelectorRef = useOnclickOutside(() => {
    dispatch(toggleShowWindow(true));
  });

  const toggleLanguageMenu = (e) => {
    e.preventDefault();
    dispatch(toggleShowWindow());

    const bodyEl = document.querySelector('body');
    bodyEl.classList.toggle('navbar__mobile-menu--active');
  };

  const changeMobileCountry = (langName) => {
    setSelectedMobileCountry(langName);
  };
  const changeMobileWindowIndex = (currentVal = -1) => {
    const browserWidth = window.innerWidth;
    if (browserWidth > 1024) {
      return;
    }
    setTimeout(() => {
      const newIndex =
        currentVal === -1 ? mobileWindowIndex - 1 : currentVal + 1;
      if (newIndex < 0) {
        dispatch(toggleShowWindow(false));
        newIndex = 0;
      }
      setMobileWindowIndex(newIndex);
    }, 10);
  };

  useEffect(() => {
    dispatch(getRegions());
  }, []);

  useEffect(() => {
    if (result?.languageItems) {
      const regions = result?.languageItems.reduce((accumulator, item) => {
        if (!accumulator.includes(item.regionName))
          accumulator.push(item.regionName);
        return accumulator;
      }, []);

      // set raw language list
      setLanguageList(result?.languageItems);

      const currLang = result?.languageItems[0];
      setCustomerLang(currLang.currentCulture);

      // set region list
      setRegionList(regions);
      if (regions?.length > 0) {
        const selectedRegion =
          result?.languageItems.find((l) => l.selected)?.regionName ||
          regions[0];
        setSelectedRegion(selectedRegion);
      }

      setCurrentLangObject(
        result?.languageItems.find((l) => l.selected) || null
      );
      setFallbackChannel(
        result?.languageItems.find((l) => l.isFallbackChannel) || {}
      );
    }
    // set main image
    if (result?.imageUrl) {
      setMainImagePath(result?.imageUrl);
    }
  }, [result]);

  useEffect(() => {
    if (selectedRegion && result?.languageItems) {
      // group by region

      const groupedByArea = result?.languageItems.reduce(
        (accumulator, item) => {
          // Get the region of the current item
          const country = item.countryName;
          const region = item.regionName;

          // If the accumulator doesn't have this region, initialize it
          if (region === selectedRegion) {
            if (!accumulator[country]) {
              accumulator[country] = [];
            }

            // Add the current item to the region group
            accumulator[country].push(item);
          }
          return accumulator;
        },
        {}
      );
      // set grouped language list
      setLanguageGroupList(groupedByArea);
    }
  }, [selectedRegion]);

  const backgroundStyle = {
    backgroundImage: `url(${mainImagePath})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
  };
  return (
    <div className="language-selector" ref={langSelectorRef}>
      <a
        href="#"
        className={`globe__link--block  ${
          showWindow ? 'globe__link--active' : ''
        }`}
        rel="nofollow"
        onClick={(e) => toggleLanguageMenu(e)}
      >
        <span
          className={`language-selector__header-content-desktop${
            !showWindow ? '--show' : ''
          }`}
        >
          <i className={`language-selector__globe globe__icon`}></i>
          <span className="globe__title">{title}</span>
        </span>
        <i
          className={` language-selector__icon--clear${
            showWindow ? '--show' : ''
          }`}
        ></i>
      </a>
      <div
        className={`language-selector__window ${
          showWindow ? 'language-selector__window--force-show' : ''
        }`}
      >
        <div className="language-selector__go-back">
          {mobileWindowIndex > -1 && (
            <div onClick={() => changeMobileWindowIndex()}>
              <i className="language-selector__icon language-selector--caret-left"></i>
              {translate('languageselector.back')}
            </div>
          )}
        </div>
        <div className="row">
          <div
            className={`small-12 large-3 language-selector__mobile-win${
              mobileWindowIndex === 0 ? '--show' : ''
            }`}
          >
            <div
              className="language-selector__window__background"
              style={backgroundStyle}
            >
              <Fragment>
                <h4>{translate('languageselector.regionalsettings')}</h4>
                <div className="language-selector__country-subheader">
                  <p>{translate('languageselector.chooseregion')}</p>
                </div>
                <ul className="language-selector__window__regions">
                  {regionList.map((region, index) => {
                    return (
                      <li
                        key={`region-${index}`}
                        className={`language-selector__window__region${
                          region === selectedRegion ? '--selected' : ''
                        }`}
                        onClick={() => {
                          setSelectedRegion(region);
                          changeMobileWindowIndex(mobileWindowIndex);
                        }}
                      >
                        <div className="language-selector__group">
                          <span>{region}</span>
                          {region === selectedRegion && currentLangObject && (
                            <p className="language-selector__group--selected">
                              {currentLangObject.countryName}
                              &nbsp;
                              {currentLangObject.languageName && (
                                <Fragment>
                                  ({currentLangObject.languageName}){' '}
                                </Fragment>
                              )}
                              <span className="language-selector__group__selected-icon"></span>
                            </p>
                          )}
                        </div>
                        <i className="language-selector__icon language-selector--caret-right"></i>
                      </li>
                    );
                  })}
                </ul>
              </Fragment>
            </div>
          </div>

          <div
            className={`small-12 large-9 language-selector__window__container language-selector__mobile-win${
              mobileWindowIndex > 0 ? '--show' : ''
            }`}
          >
            <div className="language-selector__window--title">
              <h5>{selectedRegion}</h5>
            </div>
            {mobileWindowIndex === 1 && (
              <div className="language-selector__country-subheader">
                <p>{translate('languageselector.choosecountry')}</p>
              </div>
            )}
            <ul className="language-selector__window__countries">
              {Object.entries(languageGroupList).map((country, indx) => {
                const countryName = country[1][0].countryName;
                let mobileHide = true;
                if (
                  mobileWindowIndex < 2 ||
                  (mobileWindowIndex > 1 &&
                    countryName === selectedMobileCountry)
                ) {
                  mobileHide = false;
                }
                return (
                  <li
                    key={`region-${country[0]}-${indx}`}
                    className={`language-selector__window__country${
                      mobileHide ? '--hide' : ''
                    } `}
                    data-iso={`${country[1][0].countryIsoName}`}
                    data-curr={`${country[1][0].currentCulture}`}
                  >
                    <LanguageSelectorItem
                      country={countryName}
                      languages={country[1]}
                      {...{
                        changeMobileWindowIndex,
                        mobileWindowIndex,
                        changeMobileCountry,
                      }}
                    />
                  </li>
                );
              })}
            </ul>
            {fallbackChannel && (
              <div className="language-selector__window__others">
                <h5>{translate('languageselector.others')}</h5>
                <a
                  href={fallbackChannel.url}
                  className={`language-selector__window__link`}
                >
                  {fallbackChannel.languageName}
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LanguageSelector;
